import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./ProductDeliveryReturns.module.scss";
import { ReturnsExclusions } from "../ReturnsExclusions/ReturnsExclusions";

export type Props = {
  browsePageHierarchy: Array<{ categoryId: string }>;
  showExclusionsMessaging?: boolean;
  showOutletReturnsMessage?: boolean;
};

export const ProductDeliveryReturns = ({
  browsePageHierarchy,
  showExclusionsMessaging = false,
  showOutletReturnsMessage = false,
}: Props) => {
  return (
    <div className={styles.returns} data-testid="delivery:returns">
      <h3 data-testid="delivery:returns:title">Returns</h3>
      {showExclusionsMessaging && (
        <ReturnsExclusions browsePageHierarchy={browsePageHierarchy} />
      )}

      <div className={styles.returnsCopy}>
        {showOutletReturnsMessage && (
          <p>Outlet items have the same returns policy as brand new stock.</p>
        )}
        <p>
          Return small or medium items by post or to John Lewis &amp; Partners
          and Waitrose &amp; Partners shops.
        </p>
        <p className={styles.homeCollection}>
          Large items (delivered by two people, such as appliances and
          furniture) can be returned using our{" "}
          <a
            href="https://www.johnlewis.com/customer-services/returns/how-do-i-return-an-item/home-collection"
            rel="noreferrer"
          >
            Home Collection service
          </a>
          .
        </p>
        <p>
          You can also return a Click &amp; Collect order to where you collected
          it.
        </p>
      </div>

      <div className={styles.buttons}>
        <SecondaryButton
          tag="a"
          href="https://www.johnlewis.com/customer-services/delivery-information"
        >
          More about delivery &amp; collection
        </SecondaryButton>
        <SecondaryButton
          tag="a"
          href="https://www.johnlewis.com/customer-services/returns"
        >
          More about returns &amp; refunds
        </SecondaryButton>
      </div>
    </div>
  );
};
